import GradeForm from "../../components/Forms/GradeForm";
import MainGoal from "../../components/Forms/MainGoal";
import PrimaryCategory from "../../components/Forms/PrimaryCategory";
import SubCategoryForm from "../../components/Forms/SubCategoryForm";
import BasicCard from "../BasicCard";

import Dummylayout from "../Dummylayout";
import ReportTable from "./ReportTable";

function ReportTableMain() {
    return (
        <>
        {/* <MainLayout/> */}
       <Dummylayout/>
    

            <BasicCard>
                <ReportTable/>         
           </BasicCard>
        
        </>
    )
}
export default ReportTableMain;